import { useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import type { OfferForm } from "@/shared/partnerschema";
import { useGetRules } from "@/hooks/useLocalStorage";

interface RulesPopupProps {
    open: boolean;
    onClose: () => void;
    offerData?: OfferForm;
}

function RulesPopup({ open, onClose, offerData }: RulesPopupProps) {

    const { data: rules, isLoading } = useGetRules(1, 50, offerData?.Id);
console.log("rules", rules)
    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="max-w-7xl w-[70%] h-[70%]">
                <DialogHeader>
                    <DialogTitle className="text-center text-lg font-bold">
                        AVAILABLE RAW RULE
                        {offerData?.ExchangeOfferName && (
                            <span className="ml-2 text-sm font-normal text-muted-foreground">
                                — {offerData.ExchangeOfferName}
                            </span>
                        )}
                    </DialogTitle>
                </DialogHeader>

                <div className="border rounded-md overflow-auto max-h-[500px]">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Rule ID</TableHead>
                                <TableHead>Name</TableHead>
                                <TableHead>Raw Rule</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={3} className="text-center py-6 text-muted-foreground">
                                        Loading...
                                    </TableCell>
                                </TableRow>
                            ) : rules?.total ?? 0 > 0 ? (
                                rules?.items.map((rule: any, index: number) => (
                                    <TableRow key={rule.Rule_Id ?? index}>
                                        <TableCell>{rule.Rule_Id}</TableCell>
                                        <TableCell>{rule.Name}</TableCell>
                                        <TableCell className="whitespace-pre-wrap font-mono text-sm max-w-xl">
                                            {rule.raw_rule}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3} className="text-center py-6 text-muted-foreground">
                                        No rules found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default RulesPopup;